import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import { HomeOutlined, QuestionMarkOutlined, SettingsOutlined } from '@mui/icons-material'
import { SidebarNavigationItem } from '@/features/sidebar'

interface SidebarMenuSectionProps {
  readonly isCollapsed?: boolean
}

export const SidebarMenuSection: FC<SidebarMenuSectionProps> = ({ isCollapsed = false }) => {
  return (
    <Box sx={containerSx(isCollapsed)}>
      <SidebarNavigationItem
        icon={<HomeOutlined />}
        label="Home"
        route="/"
        isCollapsed={isCollapsed}
        matchExact
      />
      <SidebarNavigationItem
        icon={<SettingsOutlined />}
        label="Settings"
        route="/settings"
        isCollapsed={isCollapsed}
      />
      <SidebarNavigationItem
        icon={<QuestionMarkOutlined />}
        label="Docs"
        route="/docs"
        isCollapsed={isCollapsed}
      />
    </Box>
  )
}

const containerSx = (isCollapsed: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: isCollapsed ? 'center' : 'stretch',
  gap: isCollapsed ? 1.5 : 0.5,
})
